// src/pages/seo/components/InfoPopover.tsx

import React from 'react';
import { bestPractices } from '@/lib/ai/fieldPrompts';
export function InfoPopover({ fieldKey }: { fieldKey: string }) {
  const bp = bestPractices[fieldKey];
  return (
    <div className="text-sm p-3 max-w-md">
      <p className="font-medium mb-1">Why it matters</p>
      <p className="mb-2 text-gray-700">{bp?.why || 'Field description coming soon.'}</p>
      {bp?.tips && (
        <ul className="list-disc pl-5 space-y-1 text-gray-700">
          {bp.tips.map((t,i)=>(<li key={i}>{t}</li>))}
        </ul>
      )}
      {bp?.related?.length ? (
        <p className="mt-2 text-xs text-gray-500">Related: {bp.related.join(', ')}</p>
      ): null}
    </div>
  );
}